// extracted by mini-css-extract-plugin
module.exports = {"time":"sectionHolder-m__time__159qD"};